var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4999 4.37492C10.2512 4.37492 4.37492 10.2512 4.37492 17.4999C4.37492 24.7487 10.2512 30.6249 17.4999 30.6249C24.7487 30.6249 30.6249 24.7487 30.6249 17.4999C30.6249 10.2512 24.7487 4.37492 17.4999 4.37492ZM1.45825 17.4999C1.45825 8.64035 8.64035 1.45825 17.4999 1.45825C26.3595 1.45825 33.5416 8.64035 33.5416 17.4999C33.5416 26.3595 26.3595 33.5416 17.4999 33.5416C8.64035 33.5416 1.45825 26.3595 1.45825 17.4999Z",
    fill: "#07364B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5001 7.29175C18.3055 7.29175 18.9584 7.94467 18.9584 8.75008V16.5988L23.9856 19.1124C24.706 19.4726 24.998 20.3485 24.6378 21.0689C24.2776 21.7893 23.4016 22.0813 22.6812 21.7211L16.8479 18.8045C16.3538 18.5574 16.0417 18.0525 16.0417 17.5001V8.75008C16.0417 7.94467 16.6947 7.29175 17.5001 7.29175Z",
    fill: "#07364B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.26e4d8c540e972f392baa33125f96d04.svg";
export { ForwardRef as ReactComponent };